var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2476 11.8218H30L25.06 6.80702C23.4696 5.19352 21.4885 4.0332 19.3159 3.44273C17.1433 2.85225 14.8558 2.85243 12.6833 3.44323C10.5108 4.03403 8.52986 5.19464 6.93968 6.80839C5.34949 8.42213 4.20609 10.4321 3.6244 12.6363M9.75241 20.1782H2V28.043M2 20.1782L6.93844 25.193C8.52886 26.8065 10.5099 27.9668 12.6825 28.5573C14.8551 29.1477 17.1427 29.1476 19.3152 28.5568C21.4877 27.966 23.4686 26.8054 25.0588 25.1916C26.649 23.5779 27.7924 21.5679 28.374 19.3637M30 3.95696V11.8187",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgRefresh;